import React from 'react';
import PropTypes from 'prop-types';

import storage from 'core/localStorage';
import { Link } from 'core/routing';
import { inWhitelabel } from 'core/whitelabel';

import { clientStore } from 'apps/client/app';
import Banner from 'components/Banner';

// WARNING: We are using the local storage to save the banner id + show flag.
// That means that when we change the banner content we should increase
// the yellowBannerConfig version or the user will not see the new banner.
const yellowBannerConfig = {
  key: 'yellow-banner',
  version: '6.0.0',
};

// It will return true if the first version is greater than the second version
export const isVersionHigher = (first, second) => {
  const precision = 10; // You can add more zeros on the right to increase the precision

  const versionParser = version => {
    const splitVersion = version.split('.');
    return splitVersion.reduce((accumulator, number, index) => {
      return (
        (accumulator || 0) +
        Number(number) * (splitVersion.length - index) ** precision
      );
    }, 0);
  };

  // parse semver to integer and compare that
  const firstVersion = versionParser(first);
  const secondVersion = versionParser(second);

  return firstVersion > secondVersion;
};

// const cleanupLegacyStorage = () => {
//   const legacyKeys = Object.keys(localStorage).filter(
//     key => yellowBannerConfig.key !== key && key.includes('-banner'),
//   );
//   legacyKeys.forEach(key => {
//     storage.remove(key);
//   });
// };

export const initYellowBanner = () => {
  // cleanupLegacyStorage();
  if (inWhitelabel()) return;
  let data = storage.get(yellowBannerConfig.key);

  if (!data || isVersionHigher(yellowBannerConfig.version, data.version)) {
    data = {
      show: true,
      version: yellowBannerConfig.version,
    };
    storage.set(yellowBannerConfig.key, data, true);
  }

  clientStore.SetHasBanner(data.show);
};

const dismissYellowBanner = () => {
  const data = {
    show: false,
    version: yellowBannerConfig.version,
  };

  storage.set(yellowBannerConfig.key, data, true);
  clientStore.SetHasBanner(data.show);
};

export default function YellowBanner() {
  return (
    <Banner
      isFixed
      disableIcon
      size='default'
      customBgColor='#ffcb00'
      isDismissable={dismissYellowBanner}
    >
      Check out our{' '}
      <Link
        name='initiative.story'
        params={{
          initiative: '+wikifactory',
          slug: 'new-tools-features-for-you',
        }}
      >
        New Features,
      </Link>{' '}
      today.
    </Banner>
  );
}

YellowBanner.propTypes = {
  updateParent: PropTypes.func,
};
